import * as React from "react";

const IconCheckboxChecked = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M22.455 0H1.545A1.547 1.547 0 0 0 0 1.545v20.909A1.547 1.547 0 0 0 1.545 24h20.91A1.547 1.547 0 0 0 24 22.454V1.545A1.547 1.547 0 0 0 22.455 0Zm-3.65 7.844-7 9.5a1.013 1.013 0 0 1-1.43.187l-5-4a1 1 0 1 1 1.25-1.561l4.187 3.35L17.2 6.656a1 1 0 1 1 1.61 1.187Z" />
  </svg>
);

export default IconCheckboxChecked;
